import { post, type RequestOptions } from "~/common/request"

export const listVideoTemplates = (
  params: API.VideoTemplate.ListParams = {},
  options?: RequestOptions,
) => {
  return post<API.VideoTemplate.ListResponse>(
    "/api/video-template/list",
    params,
    options,
  )
}

export const listTemplateCategories = (
  params: API.VideoTemplate.CategoryListParams = {},
  options?: RequestOptions,
) =>
  post<API.VideoTemplate.CategoryListResponse>(
    "/api/video-template/category/list",
    params,
    options,
  )
